const en_US = {
    info: {
        title: "Joi Button",
        info: "Information",
        null: "Empty",
        footerSubmit: "Got a clip that belongs here? Send it from the submit page.",
        toGithub: "Source on GitHub",
        notOfficial: "This site is a fan work and is not associated with the official VirtuaReal or Nijisanji (AnyColor).",
        overlapTips: "Overlapping play can't be stopped and creates a lot of playback, better refresh when you've had enough of it",
        loopTips: "This will loop your selected track, since it'll play forever, the two other functionalities are useless and will be disabled until loop is turned off",
        clipInfo: "Clip information",
        clipSource: "Source title",
        clipDate: "Date",
        clipDuration: "Time point",
        clipOriginal: "Original video",
        clipSubmitter: "Submitted by",
        clipJump: "Open the source at this time",
        clipType: { label: "Type", video: "Video", stream: "Live clip" },
        yt_channel: "Joi's Channel",
        lang: "Language: "
    },
    action: {
        toggleNavbar: "Toggle navigation bar",
        close: "close",
        copy: "copy",
        control: "Player control",
        stopvoice: "Stop current voice",
        randomplay: "Play a random clip",
        overlap: "Allow sound to overlap",
        autoplay: "Autoplay",
        loop: "Loop",
        details: "Show details",
        playing: "Now Playing：",
        noplay: "Nothing playing.",
        volume: "Volume: "
    },
    lang: {
        'zh-CN': "简体中文",
        'en-US': "English",
        'ja-JP': "日本語",
    }
}
export default en_US;
